import React, { useState } from 'react';
import { Note, createNote, uploadNotePhoto, getNotePhotoUrl } from '../api/client';
import { AddNoteModal } from './AddNoteModal';
import { ViewNoteModal } from './ViewNoteModal';

interface Props {
  roomId: number;
  notes: Note[];
  onNotesChange: () => void;
}

export function NotesList({ roomId, notes, onNotesChange }: Props) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState<Note | null>(null);
  const [savedUserName, setSavedUserName] = useState(() => 
    localStorage.getItem('userName') || ''
  );

  const handleAddNote = async (content: string, authorName: string, photo: File | null) => {
    const finalAuthorName = authorName || 'Anonymous';
    
    if (authorName) {
      localStorage.setItem('userName', authorName);
      setSavedUserName(authorName);
    }

    const newNote = await createNote(roomId, content, finalAuthorName);

    if (photo && newNote.id) {
      await uploadNotePhoto(newNote.id, photo);
    }

    onNotesChange();
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '16px' 
      }}>
        <h2 style={{ margin: 0 }}>Notes</h2>
        <button
          onClick={() => setIsAddModalOpen(true)}
          style={{
            padding: '8px 16px',
            background: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Add Note
        </button>
      </div>

      {notes.length === 0 ? (
        <p style={{ color: '#666', textAlign: 'center', padding: '20px 0' }}>
          No notes yet. Add one above.
        </p>
      ) : (
        <div>
          {notes.map(note => {
            const photoUrl = getNotePhotoUrl(note.photo_url);
            return (
              <div
                key={note.id}
                onClick={() => setSelectedNote(note)}
                style={{
                  padding: '12px',
                  borderBottom: '1px solid #eee',
                  cursor: 'pointer',
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'flex-start'
                }}
              >
                {photoUrl && (
                  <img
                    src={photoUrl}
                    alt=""
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'cover',
                      borderRadius: '4px',
                      flexShrink: 0
                    }}
                  />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical' as const
                  }}>
                    {note.content}
                  </div>
                  <div style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>
                    {note.author_name} &bull; {formatDate(note.created_at)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <AddNoteModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSubmit={handleAddNote}
        initialAuthorName={savedUserName}
      />

      <ViewNoteModal
        note={selectedNote}
        isOpen={selectedNote !== null}
        onClose={() => setSelectedNote(null)}
      />
    </div>
  );
}
